// @flow

export const primary = "Patrick Hand, cursive";
export const secondary = `"Open Sans", sans-serif`;
